import { render, staticRenderFns } from "./BetSlipTabOptions.vue?vue&type=template&id=814d9a30&"
import script from "./BetSlipTabOptions.vue?vue&type=script&lang=js&"
export * from "./BetSlipTabOptions.vue?vue&type=script&lang=js&"
import style0 from "./BetSlipTabOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports